// extracted by mini-css-extract-plugin
export default {"root":"FeaturedWorkshops_root__yzXLq","listingsHolder":"FeaturedWorkshops_listingsHolder__uWtXS","listingCard":"FeaturedWorkshops_listingCard__ZM7xw"};